export enum PresencaDadaPor {
  Titular = 'T',
  Representante = 'R',
}
